import { render, staticRenderFns } from "./HelpCenterLink.vue?vue&type=template&id=13c81efa&scoped=true&"
import script from "./HelpCenterLink.vue?vue&type=script&lang=js&"
export * from "./HelpCenterLink.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterLink.vue?vue&type=style&index=0&id=13c81efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c81efa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VBtn,VIcon})
